import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useSheets } from 'global/cnr/contexts/useHelpers/useSheets';
import { gEnums } from 'global/enums/globalEnums';
import { settingsHelpers } from 'global/viewSettings/helpers/settingsHelpers';
import { mediaHelpers } from 'projectSpecific/sports/importing/mediaResults';
import { useCallback, useContext, useMemo, useState } from 'react';
import { SportsDistrictContext } from '../cnr/contexts/SportsDistrictContext';
import { _sportsFormProps, SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { _matchFoundTypes } from '../cnr/reducers/reducerHelpers/seasonSportsMatchData';
import { getMatchInfo } from '../cnr/reducers/reducerHelpers/sportsGsUpdates';
import { _sdm } from '../elements/dashboard/SportsDashboard';
import { _fetchModes } from '../elements/matches/MatchDataUpdate';
import { _mediaHeaders, _matchStatusTypes } from '../helpers/sportsEnums';
import { getMatchUpdates, groupByMatchStatusTypes } from '../helpers/sportsGsData';
import { ammendTeamName } from '../helpers/teams';
import { useSportsMatches } from './useSportsMatches';

const useGoogleSports = ({
  currentMenuKey,
  sportsDataMode,
  gameScoringType,
}) => {

  const { getMatches_flat } = useSportsMatches()
  const { sheets_fns } = useSheets()

  const [fetching, setFetching] = useState()

  const parentContext = useContext(ParentContext);
  const { states, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainRt, mainDb } = app_state

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { gls_scores } = district_data ?? {}
  const gls_score = gls_scores?.[pathViews?.sports]

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}

  const {
    teams_info,
    currentSeason_info,
    matches_info,
  } = sportsSeason_state ?? {}

  const { latestSeason, _sportsAbr } = currentSeason_info ?? {}

  const teams = teams_info?.teams

  const matches_flat = useMemo(() => {
    if (!matches_info) return;
    return getMatches_flat({ matches_info })
  }, [matches_info])

  const formProps = useMemo(() => {
    const _form_props = _sportsFormProps[sportsDataMode]
    const _appFormItems = {}
    if (_form_props) {
      Object.keys(_form_props).forEach(fp => {
        _appFormItems[fp] = settingsHelpers.newPropEditItem(fp, gEnums.formItemTypes.text, null, null, true)
      })
    }
    return _form_props
  }, [sportsDataMode])

  const linkValues = useMemo(() => {
    const _linkValues = {}
    switch (sportsDataMode) {
      case _sdm.district.updateDistrictSeasonScores:
        const xxx = gls_scores && currentMenuKey && gls_scores[currentMenuKey] ? gls_scores[currentMenuKey] : {}
        if (formProps) {
          Object.keys(formProps).forEach(fp => {
            _linkValues[fp] = xxx ? xxx[fp] : null
          })
        }
        break;
      default:
        if (formProps) {
          Object.keys(formProps).forEach(fp => {
            _linkValues[fp] = gls_score?.[fp] || null
          })
        }
    }
    return _linkValues
  }, [currentMenuKey])


  const getGsCallValues = (opts) => {
    let forMedia;
    let forPlayoffs
    let usePure;
    const { fetchMode } = opts
    const gsValues = _.clone(linkValues)
    gsValues.fetchMode = fetchMode
    switch (fetchMode) {
      case _fetchModes.seasonResults:
        gsValues.sheetName = linkValues.scoresSheet
        break;
      case _fetchModes.playoffResults:
        gsValues.sheetName = linkValues.playoffScoresSheet
        forPlayoffs = true
        break;
      case _fetchModes.mediaResults:
        gsValues.sheetName = linkValues.scoresSheet
        forMedia = true
        break;
      case _fetchModes.mediaPlayoffResults:
        forPlayoffs = true
        forMedia = true
        gsValues.sheetName = linkValues.playoffScoresSheet
        break;
      case _fetchModes.wpialResults:
        gsValues.googleSheetsId = '1ntWkPyKV9DYdwDcBDYshATj2HAfI-iAzYHHV48UYgN0'
        gsValues.sheetName = '3A Results'
        gsValues.ignoreStartCase = true
        usePure = true
        break;
      default:
      // nothing
    }
    return { gsValues, forMedia, forPlayoffs, usePure }
  }

  const getMedia_results = useCallback(
    async ({ year, dateGroupKeys, forPlayoffs, forRefresh, callback }) => {
      mediaHelpers.getMedia_results(
        dateGroupKeys,
        forPlayoffs,
        gls_score,
        year,
        _sportsAbr,
        teams,
        forRefresh,
        callback
      )
    }, []);

  const handleGet_gsMatches = useCallback(async ({ opts, callback, callback_error }) => {

    // set fetching
    setFetching(true)

    const cb_afterAmmend = (matchResultsInfo) => {
      setFetching(false)
      callback(matchResultsInfo)
    }

    const cb_afterGsFetch = (gsValues, results_gs, team) => {
      const results_gs_actual = _.filter(results_gs, (match) => (!_.isNil(match.startDate) && !_.isNil(match.away) && !_.isNil(match.home)));

      const action = { gsValues, results_gs: results_gs_actual, team, forPlayoffs }

      ammend_matchesFromGsOrMedia(
        {
          mainDb,
          matches_flat,
          matches_info,
          teams: teams_info.teams,
          gameScoringType,
          callback: cb_afterAmmend,
          action
        }
      )
    }

    const cb_gse = (matchResultsInfo) => {
      setFetching(false)
      callback(matchResultsInfo)
    }

    // get the gsCall options
    const { gsValues, forMedia, forPlayoffs, usePure } = getGsCallValues(opts)

    // get the matches from the google sheet
    if (gsValues.sheetName) {
      const _latestSeason = opts?.latestSeason || latestSeason
      fn_cls.getGoogleSheetRange(gsValues || gls_score, cb_afterGsFetch, cb_gse, gsValues?.ignoreStartCase, null, _latestSeason, forPlayoffs, forMedia, usePure)
    }
  }, []);

  const handleGet_gsRankings = useCallback(
    async ({ opts, callback }) => {
      const { gsValues } = getGsCallalues(opts)
      fn_cls.getGoogleSheetRange(
        gsValues || gls_score,
        callback,
        null,
        null,
        null,
        latestSeason)
    }, []);

  const handleGet_gsRosters = useCallback(
    async ({ opts, callback }) => {
      const { gsValues } = getGsCallalues(opts)
      fn_cls.getGoogleSheetRange(gsValues ? gsValues : gls_score, callback)
    }, []);

  return {
    getMedia_results,
    handleGet_gsMatches,
    handleGet_gsRankings,
    handleGet_gsRosters,
    linkValues,
    fetching
  }

}

export default useGoogleSports

const ammend_matchesFromGsOrMedia = (
  {
    mainDb,
    matches_flat, // values
    matches_info, // matches, matches_playoffs
    teams,
    gameScoringType,
    action,
    callback
  }
) => {

  const {
    gsValues,
    results_gs,
    mediaMatches,
    forPlayoffs,
    forRefresh
  } = action

  const { fetchMode } = gsValues ?? {}
  const matches_gs = results_gs ? results_gs : mediaMatches

  switch (fetchMode) {
    case _fetchModes.wpialResults:
      parseSheetData(results_gs.values)
      break;

    default:
      const _matches_info = []

      // from the app
      const { matches, matches_playoffs } = matches_info ?? {}
      const { actual } = matches_flat ?? {}

      // these are the flattend existing matches from the app
      const { season: matches_flat_season, playoffs: matches_flat_playoff } = actual ?? {}

      if (matches_gs && (matches_flat_season || matches_flat_playoff)) {

        // const xxx = groupByMatchStatusTypes(matches_gs)
        // console.log('matches_gs', matches_gs)
        // console.log('xxx', xxx)

        // get only the valid matches
        const _matches_gs = _.filter(matchesValues(matches_gs), isValidMatch)
        const _matches_flat_season = _.filter(matchesValues(matches_flat_season), isValidMatch)

        const { matchesNon_appNotGs, matchesNon_gsNotApp } = getSourceMapDiffs(_matches_flat_season, _matches_gs)

        normalizeGsMatches_levelAndSections(matches_gs, ['section', 'level'], ['sections', 'levels'])

        ammendMatchTeamNames(matches_gs)

        const matchResultsInfo = getMatchUpdates(mainDb, matches_info, matches_gs, teams, forPlayoffs, forRefresh, gameScoringType)

        matchResultsInfo.matchesNon_appNotGs = matchesNon_appNotGs
        matchResultsInfo.matchesNon_gsNotApp = matchesNon_gsNotApp
        matchResultsInfo.matches_gs = matches_gs

        const m_flat = forPlayoffs ? matches_flat_playoff : matches_flat_season
        const _matches_flat = _.cloneDeep(m_flat)
        const _matches_db = forPlayoffs ? matches_playoffs : matches

        // loop the matches_gs
        _.forEach(matches_gs, (match_gs, dk) => {
          match_gs._matchStatusTypes = []
          const match_info = getMatchInfo(_matches_flat, match_gs, teams, _matches_db)
          _matches_info.push(match_info)
        })

        const matches_info_grouped = _.groupBy(_matches_info, 'matchFoundType')

        _.forEach(matches_info_grouped, (matches_info_group, mft) => {
          switch (mft) {
            case _matchFoundTypes.cancelled:
              // nothing
              break;

            case _matchFoundTypes.existingDb:
            case _matchFoundTypes.new:
              _.forEach(matches_info_group, (_match_info, mgk) => {
                const _match_flat = _matches_flat[_match_info.matchFlatKey]
                if (_match_flat) {
                  _match_flat._matchStatusTypes = _match_info.matchStatusTypes
                  ammendFlatMatch(_match_flat, _match_info)
                }
              })
              break;
            default:
            // nothing
          }
        })

        mediaHelpers.createAlignmentsFromMatches(matches_gs, teams)

        const { matchUpdates_dot } = matchResultsInfo ?? {}

        createAlignments(matchUpdates_dot)

        callback(matchResultsInfo, forPlayoffs)
      }
  }

}

const getSourceMapDiffs = (_matches_flat_season, _matches_gs) => {

  const matchesNon_appNotGs = _.differenceBy(
    matchesValues(_matches_flat_season),
    matchesValues(_matches_gs),
    getMatchKey
  )

  const _matches_gs_nonCancelled = _.filter(_matches_gs, (match) => (match?.updateTypes !== 'Cancelled'));

  const matchesNon_gsNotApp = _.differenceBy(
    matchesValues(_matches_gs_nonCancelled),
    matchesValues(_matches_flat_season),
    getMatchKey
  )

  return {
    matchesNon_appNotGs,
    matchesNon_gsNotApp
  }
}

function parseSheetData(sheetData) {

  const teams = {};

  let currentTeams = [];
  let currentHeaders = [];
  let currentMatchIndices = {};

  const toCamelCase = (str) => {
    return _.camelCase(str)
  };

  for (let rowIndex = 0; rowIndex < sheetData.length; rowIndex++) {
    const row = sheetData[rowIndex];
    if (row.length === 0 || row.every(cell => !cell)) {
      // Empty row, reset context
      currentTeams = [];
      currentHeaders = [];
      continue;
    }

    // Identify all header sections in the row
    let headerStartIndices = [];
    row.forEach((cell, index) => {
      if (cell === "DATE") {
        headerStartIndices.push(index);
      }
    });

    if (headerStartIndices.length > 0) {
      // There are one or more header sections in the row
      const previousRow = sheetData[rowIndex - 1] || [];

      currentTeams = headerStartIndices.map((startIndex, headerIndex) => {
        const endIndex = row.indexOf("S/NS", startIndex);
        const headers = row.slice(startIndex, endIndex + 1).map(toCamelCase);
        const teamName = previousRow[startIndex]?.trim() || `Unknown Team ${headerIndex}`;
        const _teamName = ammendTeamName(teamName)
        if (!teams[_teamName]) {
          teams[_teamName] = { matches: {} };
          currentMatchIndices[_teamName] = 0;
        }
        return { teamName: _teamName, headers, startIndex, endIndex };
      });
      continue; // Skip processing the header row as a match
    }

    // Process rows as match data under each team's headers
    if (currentTeams.length > 0) {
      currentTeams.forEach(({ teamName, headers, startIndex, endIndex }) => {

        const matchData = row.slice(startIndex, endIndex + 1);
        const match = {};
        headers.forEach((header, index) => {
          switch (header) {
            case 'opponenxxxt':
              match[header] = ammendTeamName(matchData[index]) ?? "";
            default:
              match[header] = matchData[index] ?? "";
          }
        });
        // const _teamName = ammendTeamName(teamName)
        teams[teamName].matches[`match_${currentMatchIndices[teamName]++}`] = match;
      });
    }
  }

  return teams;
}

const normalizeGsMatches_levelAndSections = (matches_gs, checkProps, ammendProps) => {
  _.forEach(matches_gs, (match_gs) => {
    _.forEach(checkProps, (checkKey, i) => {
      const ammendKey = ammendProps[i];
      const value = _.get(match_gs, checkKey);
      if (value && !_.get(match_gs, ammendKey)) {
        if (ammendKey === "sections" && !isNaN(Number(value)) && _.isFinite(Number(value))) {
          _.set(match_gs, ammendKey, `section${Number(value)}`);
        } else {
          _.set(match_gs, ammendKey, value);
        }
      }
      _.unset(match_gs, checkKey);
    });
  });

  _.forEach(matches_gs, (match_gs) => {
    const { home, away, _lsp } = match_gs
    if (_lsp?.level === 'tbd') {
      const _h = _.find(teams, { name: home })
      const _a = _.find(teams, { name: away })
      const _levels_h = _h?.levels
      const _levels_a = _a?.levels
      if (_levels_h && _levels_a && (_levels_h === _levels_a)) {
        match_gs.levels = _levels_h
      } else {
        match_gs.levels = _mediaHeaders.nonLevel
      }
    }
  })

  return matches_gs;
};

/**
 * Changes the team names to names to the correct names, if needed.
 * @param {object} matches_gs 
 */
const ammendMatchTeamNames = (matches_gs) => {
  Object.keys(matches_gs).forEach(k => {
    const match_gs = matches_gs[k]
    const { home, away } = match_gs
    if (home && away) {
      match_gs.home = ammendTeamName(home)
      match_gs.away = ammendTeamName(away)
    }
  })
}

/**
 * 
 * @param {object} match_flat 
 * @param {object} match_group 
 */
const ammendFlatMatch = (match_flat, match_group) => {

  const { match_gs, matchScores, inversed } = match_group ?? {}
  let { startDate: startDate_gs, postponed, cancelled, exhibition } = match_gs ?? {}

  if (!match_flat._matchStatusTypes) {
    match_flat._matchStatusTypes = []
  }

  // chaget the date if needed
  if (match_group && startDate_gs && startDate_gs !== match_group.startDate) {
    match_flat._matchStatusTypes.push(_matchStatusTypes.dateChanged)
    match_flat._newStartDate = startDate_gs
  }

  // still updating the match, but ammending the matchStatusTypes
  if (postponed) { match_flat._matchStatusTypes.push(_matchStatusTypes.postponed) }
  if (cancelled) { match_flat._matchStatusTypes.push(_matchStatusTypes.cancelled) }
  if (exhibition) { match_flat._matchStatusTypes.push(_matchStatusTypes.exhibition) }

  if (matchScores && matchScores.gs) {
    // if `gs` has scores for `home` and `away`
    if (_.isNumber(matchScores.gs.away) && _.isNumber(matchScores.gs.home)) {
      // if `found` has scores for `home` and `away`
      if (matchScores.db && _.isNumber(matchScores.db.away) && _.isNumber(matchScores.db.home)) {
        // if `found` and `gs` scores are different
        if ((matchScores.gs.home !== matchScores.db.home) || (matchScores.gs.away !== matchScores.db.away)) {
          match_flat._matchStatusTypes.push(_matchStatusTypes.scoreChanged)
          if (inversed) {
            inverseMatch(match_flat, matchScores)
          } else {
            match_flat.awayScore = parseInt(matchScores.gs.away)
            match_flat.homeScore = parseInt(matchScores.gs.home)
          }
        }
      } else {
        // if `gs` has scores for `home` and `away`
        if (_.isNumber(matchScores.gs.away) && _.isNumber(matchScores.gs.home)) {
          match_flat._matchStatusTypes.push(_matchStatusTypes.scoreChanged)
          if (inversed) {
            inverseMatch(match_flat, matchScores)
          } else {
            match_flat.awayScore = parseInt(matchScores.gs.away)
            match_flat.homeScore = parseInt(matchScores.gs.home)
          }
        }
      }
    }
  }
}

const createAlignments = (matchDataUpdates) => {

  const { allUpdates: matches } = matchDataUpdates ?? {}

  const levels = {};

  _.forEach(matches, (matchesByLevel, level) => {
    if (!levels[level]) {
      levels[level] = {
        name: level,
        sections: {}
      };
    }

    _.forEach(matchesByLevel, (match) => {
      const awaySection = match.away.sections;
      const homeSection = match.home.sections;

      if (!levels[level].sections[awaySection]) {
        levels[level].sections[awaySection] = { teams: {} };
      }
      if (!levels[level].sections[homeSection]) {
        levels[level].sections[homeSection] = { teams: {} };
      }

      levels[level].sections[awaySection].teams[match.away.id] = { name: match.away.name, id: match.away.id };
      levels[level].sections[homeSection].teams[match.home.id] = { name: match.home.name, id: match.home.id };
    });
  });

}

const getMatchKey = (match) => {
  return [
    match.startDate,
    match.home,
    match.away,
  ].join('|')
}

const matchesValues = value => _.isArray(value) ? value : _.values(value)
const isValidMatch = m => m?.startDate && m?.away && m?.home

const inverseMatch = (match_flat, matchScores) => {
  match_flat.old = {
    away: match_flat.away,
    home: match_flat.home
  }
  match_flat.away = match_flat.old.home
  match_flat.home = match_flat.old.away
  match_flat.awayScore = matchScores.gs.away
  match_flat.homeScore = matchScores.gs.home
  match_flat._matchStatusTypes.push(_matchStatusTypes.inversed)
}